module.exports = __webpack_public_path__ + "static/media/nima_talking_didi.4fb94514.png";